module.exports = __webpack_public_path__ + "static/card-ocean-carriers-2-02b40aaa09dddd7b721f11673c7292ad.jpg";